// src/services/ServiceService.js
import api from "@/services/api";
import authHeader from "./authHeader";

export const serviceService = {
  async fetchAllServices() {
    return await api.get("/services", { headers: authHeader() });
  },
  fetchService(id) {
    return api.get(`/services/${id}`, { headers: authHeader() });
  },
  fetchCreateService(data) {
    return api.post("/services", data, { headers: authHeader() });
  },
  fetchUpdateService(id, data) {
    return api.put(`/services/${id}`, data, { headers: authHeader() });
  },
  fetchDeleteService(id) {
    return api.delete(`/services/${id}`, { headers: authHeader() });
  },
};

export default serviceService;
